import { StringUtils } from 'src/app/services/utils/string.utils';

export class TaskObject {
  public selected: boolean;

  constructor(private id: number, private errorDate: Date, private activityStartDate: Date,
    private branch: string, private operation: string, private client: string, private serviceId: string,
    private crmId: string, private type: string, private error: string, private description: string,
    private process: string, private assignee: string, private queue: string) {
    this.selected = false;
  }

  public static create(): TaskObject {
    return new TaskObject(null, null, null, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE,
      StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE,
      StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE);
  }

  public getId(): number {
    return this.id;
  }

  public getErrorDate(): Date {
    return this.errorDate;
  }

  public getActivityStartDate(): Date {
    return this.activityStartDate;
  }

  public getBranch(): string {
    return this.branch;
  }

  public getOperation(): string {
    return this.operation;
  }

  public getClient(): string {
    return this.client;
  }

  public getServiceId(): string {
    return this.serviceId;
  }

  public getCrmId(): string {
    return this.crmId;
  }

  public getType(): string {
    return this.type;
  }

  public getError(): string {
    return this.error;
  }

  public getDescription(): string {
    return this.description;
  }

  public getProcess(): string {
    return this.process;
  }

  public getAssignee(): string {
    return this.assignee;
  }

  public getQueue(): string {
    return this.queue;
  }
}
